import SVG from 'react-inlinesvg';
import type { Props as InlineSVGProps } from 'react-inlinesvg';
import type { StaticImageData } from 'next/image';

interface CoreIconProps {
  src: InlineSVGProps['src'] | StaticImageData;
  width?: InlineSVGProps['width'];
  height?: InlineSVGProps['height'];
  className?: InlineSVGProps['className'];
  color?: InlineSVGProps['color'];
  onClick?: InlineSVGProps['onClick'];
  style?: InlineSVGProps['style'];
  tabIndex?: InlineSVGProps['tabIndex'];
}

export const CoreIcon = (props: CoreIconProps) => {
  const { src: _src, ...rest } = props;
  const src = typeof _src === 'object' ? _src.src : _src;

  return (
    <SVG
      {...rest}
      src={src}
      style={{
        minWidth: props.width ? `${rest.width}px` : undefined,
        ...props.style,
      }}
    />
  );
};

export type IconProps = Omit<CoreIconProps, 'src'>;
